export class CookieHelper {
    static setCookie(name: string, value: string, days?: number): void {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; samesite= strict; secure;";
    }

    static getCookie(name: string): string | null {
        const nameLength = (name.length + 1);
        return document.cookie
            .split(';')
            .map(c => c.trim())
            .filter(cookie => {
                return cookie.substring(0, nameLength) === `${name}=`;
            })
            .map(cookie => {
                return decodeURIComponent(cookie.substring(nameLength));
            })[0] || null;
    }

    static eraseCookie(name: string): void {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict; Secure;';
    }
}